module.exports = __webpack_public_path__ + "static/1-b06f38c636efd430319f94cefa63a06b.jpg";